export const tabs = {
  root: {
    transitionDuration: "{transition.duration}",
  },
  tablist: {
    borderWidth: "0",
    background: "{surface.bg-grey-contrast}",
    borderColor: "transparent",
  },
  tab: {
    background: "transparent",
    hoverBackground: "{surface.bg-white}",
    activeBackground: "{surface.bg-white}",
    borderWidth: "1px",
    borderColor: "transparent",
    hoverBorderColor: "transparent",
    activeBorderColor: "transparent",
    color: "{text.caption}",
    hoverColor: "{text.body}",
    activeColor: "{text.body}",
    padding: "{padding.4} {padding.10}",
    fontWeight: "600",
    margin: "0",
    gap: "0",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}",
    },
  },
  tabpanel: {
    background: "transparent",
    color: "inherit",
    padding: "0",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "inset {focus.ring.shadow}",
    },
  },
  navButton: {
    background: "{tabs.tablist.background}",
    color: "{text.caption}",
    hoverColor: "{text.body}",
    width: "2.5rem",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}",
    },
  },
  activeBar: {
    height: "0",
    bottom: "-1px",
    background: "{primary.default}",
  },
  colorScheme: {
    light: {
      navButton: {
        shadow: "-40px 0px 10px 10px rgba(255, 255, 255, 0.6)",
      },
    },
    dark: {
      navButton: {
        shadow: "-40px 0px 10px 10px rgba(255, 255, 255, 0.2)",
      },
    },
  },
  extend: {
    ui: {
      tablist: {
        margin: "0 0 16px 0",
        padding: "{padding.6}",
        gap: "{gap.12}",
        borderRadius: "{border.radius.6}",
      },
      tab: {
        borderRadius: "{border.radius.6}",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-tablist {
      margin: ${dt("tabs.ui.tablist.margin")};
      padding: ${dt("tabs.ui.tablist.padding")};
      border-radius: ${dt("tabs.ui.tablist.border.radius")};
      background: ${dt("tabs.tablist.background")};
      flex-shrink: 0;
    }

    .p-tablist-tab-list {
      gap: ${dt("tabs.ui.tablist.gap")};
    }

    .p-tab {
      border-radius: ${dt("tabs.ui.tab.border.radius")};
      justify-content: center;
      flex: 1 0 auto;
    }

    /* New UI Chat specific styling */
    .chat-tabs-new-ui .p-tab:hover,
    .chat-tabs-new-ui .p-tab[data-p-active="true"] {
      background: ${dt("highlight.support")} !important;
    }
  `,
};
